// extracted by mini-css-extract-plugin
module.exports = {"filters":"VJRX0qrV","title":"MLkpFoYy"};